import { tProvidersProps } from '../../../../../../providers/LayoutProvider/Layout.types.ts';
import { EventBubbleContext } from './EventBubble.constants.ts';
import { useEventBubble } from './EventBubble.hook.ts';

export default function EventBubbleProvider(props: tProvidersProps) {
  const { children } = props;
  const messageBubble = useEventBubble();

  return (
    <EventBubbleContext.Provider value={messageBubble}>
      {children}
    </EventBubbleContext.Provider>
  );
}
